import React, { useEffect, useState} from 'react'

type DelayedRenderProps = {
  children?: React.ReactNode
  delay?: number
}

export function DelayedRender(props: DelayedRenderProps) {
  const { children, delay = 0 } = props
  const [delayed, setDelayed] = useState<boolean>(true)

  useEffect(() => {
    const timeout = setTimeout(() => setDelayed(false), delay)
    return () => clearTimeout(timeout)
  }, [delay])

  return (
    <>
      {!delayed ? children : null}
    </>
  )
}

export default DelayedRender